import http from "../../http-common";

export default class {
  getEventCategory() {
    let url = `/events/category`;

    return http.get(url);
  }
}